import React, { useState, useEffect, useContext } from "react";
import listApi from "../../services/api";
import './VoucherSelector.css'
const VoucherSelector = ({ onSelectVoucher, userData }) => {
  const [vouchers, setVouchers] = useState([]);
  const [selectedVoucher, setSelectedVoucher] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const fetchVouchers = async () => {
      if (!userData?.session_id) {
        console.error("Session ID không hợp lệ");
        return;
      }
      try {
        const response = await fetch(
          listApi.listMyVoucher,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              session_id: userData?.session_id,
            }),
          }
        );
        const data = await response.json();
        if (data.code === 200 && Array.isArray(data.list_voucher)) {
          setVouchers(data.list_voucher);
        } else {
          console.error("Dữ liệu API không hợp lệ:", data);
        }
      } catch (error) {
        console.error("Lỗi khi lấy danh sách voucher:", error);
      }
    };
    fetchVouchers();
  }, [userData]);


  const handleSelect = (voucher) => {
    console.log("Voucher được chọn:", voucher);
    setSelectedVoucher(voucher);
    onSelectVoucher(voucher);
    setIsOpen(false);
  };

  return (
    <div>
      {/* Nút mở modal */}
      <button style={{ backgroundColor: '#ffdb00' }}onClick={() => { setIsOpen(true)}}  className="btn-pay" >
        Chọn ưu đãi
      </button>
      {isOpen && (
        <div className="modal-overlay">
          <div  className="modal-content">
            <h3>Chọn Voucher</h3>
            {vouchers.length > 0 ? (
              <ul style={{ listStyle: "none", padding: 0 }}>
                {vouchers.map((voucher) => (
                  <div
                    key={voucher.ID}
                    onClick={() => handleSelect(voucher)}
                    style={{
                      cursor: "pointer",
                      padding: "10px",
                      borderBottom: "1px solid #ddd",
                      background: selectedVoucher?.ID === voucher.ID ? "#e0f7fa" : "white", // Thay đổi màu nền nếu voucher đang được chọn
                    }}
                    onMouseEnter={(e) => (e.target.style.background = selectedVoucher?.ID === voucher.ID ? "#e0f7fa" : "#f5f5f5")}
                    onMouseLeave={(e) => (e.target.style.background = selectedVoucher?.ID === voucher.ID ? "#e0f7fa" : "white")}
                  >
                    <p>{voucher.VoucherCode} - Giảm {voucher.discount ? voucher.discount + "%" : "Không xác định"}</p>
                    {/* <p>{voucher.voucher_state}</p> */}
                  </div>
                ))}
              </ul>
            ) : (
              <p>Không có voucher khả dụng</p>
            )}
            <button
              className="btn-closeModal"
              onClick={() => setIsOpen(false)}
              onMouseEnter={(e) => (e.target.style.background = "#cc0000")}
              onMouseLeave={(e) => (e.target.style.background = "#ff4d4d")}
            >
              Đóng
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default VoucherSelector;
